var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5V14.5H12V5H4Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7C4.49999 7 4 6.5 4 6V5C4 4.5 4.49999 4 5 4H11C11.5 4 12 4.5 12 5V6C12 6.5 11.5 7 11 7H5Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5C12 13.0304 12.2107 13.5391 12.5858 13.9142C12.9609 14.2893 13.4696 14.5 14 14.5C14.5304 14.5 15.0391 14.2893 15.4142 13.9142C15.7893 13.5391 16 13.0304 16 12.5C16 11.9696 15.7893 11.4609 15.4142 11.0858C15.0391 10.7107 14.5304 10.5 14 10.5C13.4696 10.5 12.9609 10.7107 12.5858 11.0858C12.2107 11.4609 12 11.9696 12 12.5Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.3bd7a96aaba6255d9dd953d59342bd48.svg";
export { ForwardRef as ReactComponent };